import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { SERIAL_NUMBER } from '../../../../filters/constants';
import type { CriteriaInformations } from '../../../../pages/products-page/purchase-orders/filter-options/types';
import { messages } from './messages';

export const SerialNumber = {
  id: SERIAL_NUMBER,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'SerialNumber',
  displayName: <FormattedMessage {...messages.serialNumber} />,
  render: (criteriaInformations: CriteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
